export const mobileViewDataLocators = {
  mobile_view_back_link: 'mobile_view_back_link'
}